<div
  class="bd-search-results-tab"
  [style]="{ height: 'calc(100vh - 44px - ' + filtersHeight() + 'px)' }"
  *transloco="let t; scope: 'featureSearch'"
>
  @if (!loading() && sortedViewItems().length === 0) {
    <bd-search-tab-empty-state
      data-id="view-search-results-empty"
      [titleKey]="'featureSearch.tabEmptyState.noViewsTitle'"
      [descriptionKey]="'featureSearch.tabEmptyState.noViewsDescription'"
      [links]="emptyStateLinks()"
      (scopeSelected)="switchScope.emit($event)"
    ></bd-search-tab-empty-state>
  } @else {
    <div class="flex pt-4 justify-end pb-6 items-end gap-6">
      <bd-select
        [settings]="sortSettings"
        [selectedOption]="selectedSortOption()"
        (selectedOptionChange)="onSortChange($event)"
        data-id="view-sort-select"
      />

      <bd-select
        [settings]="displaySettings"
        [selectedOption]="displayOption() === 'grid' ? gridOption : listOption"
        (selectedOptionChange)="onDisplayChange($event)"
        data-id="view-display-select"
      />
    </div>

    <div class="bd-scrollable-results" data-id="view-search-results-scroll">
      @if (!loading()) {
        @if (displayOption() === 'grid') {
          <bd-item-grid
            data-id="view-search-results"
            [items]="listItems()"
            [size]="'small'"
          ></bd-item-grid>
        } @else {
          <bd-item-view
            data-id="view-search-results"
            [data]="listItems()"
            [columns]="viewColumns"
            [selectionMode]="'single'"
            [tScope]="'featureWorkspaces'"
            (selectedItemsChange)="onSelectedItemsChange($event)"
            (itemDoubleClick)="onItemDoubleClick($event)"
          ></bd-item-view>
        }
      } @else if (displayOption() === 'grid') {
        <bd-item-grid-loading
          data-id="loading-view-search-results"
          [loadingItemsCount]="pageSize()"
          [size]="'small'"
        ></bd-item-grid-loading>
      } @else {
        <bd-item-view-loading
          data-id="loading-view-search-results"
          [loadingItemsCount]="pageSize()"
          [columns]="viewColumns"
          [tScope]="'featureWorkspaces'"
        ></bd-item-view-loading>
      }

      @if (totalCount() > pageSize()) {
        <bd-pagination
          class="bd-pagination mt-6"
          data-id="view-results-page"
          [currentPage]="currentPageIndex() + 1"
          [totalRecords]="totalCount()"
          [pageSize]="pageSize()"
          [paginationType]="'regular'"
          (currentPageChange)="onPageChange($event)"
        ></bd-pagination>
      }
    </div>
  }
</div>
